import { call, put, takeLatest } from 'redux-saga/effects';
import {
    FETCH_GENERAL_DETAILS_REQUEST,
    fetchGeneralDetailsSuccess,
    fetchGeneralDetailsFailure,
} from './vdc-instance.action';
import { fetchGeneralDetailsApi } from './vdc-instance.service';
import { showLoader, hideLoader } from '../../store/model/model.action';

function* fetchGeneralDetailsSaga(action: { type: string; payload: any }): Generator<any, void, any> {
    try {
        yield put(showLoader());
        const response = yield call(fetchGeneralDetailsApi, action.payload?.courseInstanceID);
        if (response?.success) {
            yield put(fetchGeneralDetailsSuccess(response.data));
        } else {
            const message = response?.message || 'Failed to fetch general details';
            yield put(fetchGeneralDetailsFailure(message));
        }
        yield put(hideLoader());
    } catch (error: any) {
        yield put(fetchGeneralDetailsFailure(error?.message || 'Failed to fetch general details'));
        yield put(hideLoader());
    }
}

export {
    fetchGeneralDetailsSaga,
};

export default function* viewDeployedCourseInstanceSaga() {
    yield takeLatest(FETCH_GENERAL_DETAILS_REQUEST, fetchGeneralDetailsSaga);
}
